import styled from "styled-components/macro";


export const SettingAlertMessage = styled.div`
    font-size: .5rem;
    text-align: center;
    display: flex;
    align-items: center;
    height: 100%;
`;